import {
  IconButton,
  IconButtonProps,
  Icons,
  mergeSx,
} from '@cast/design-system';

type Props = {
  onClick: () => void;
} & Omit<IconButtonProps, 'onClick'>;

export const ExportFileButton = ({ onClick, testId, ...rest }: Props) => {
  return (
    <IconButton
      variant="ghost"
      size="sm"
      onClick={(e) => {
        e.stopPropagation();

        onClick();
      }}
      data-testid={testId}
      {...rest}
      sx={mergeSx({ ml: 'auto' }, rest.sx)}
    >
      <Icons.DownloadSimple />
    </IconButton>
  );
};
